import React from 'react'

function MapMarker({ logo }) {
  return (
    <img src={logo} style={{width:100}} alt='mapmarker'/>
  )
}

export default MapMarker
